import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@emotion/css';

import { useStyles } from './facts-card.styles';
import { FactsItem } from './facts-card.model';

export const FactsCard = ({
  title, content, list, icon, isReverse, isRowReverse, isRow, isWide, isNarrow, isSmallMobile,
}: FactsItem): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={cx(classes.root, {
      [classes.rowReverse]: isRowReverse,
      [classes.row]: isRow,
      [classes.reverse]: isReverse,
      [classes.wide]: isWide,
      [classes.narrow]: isNarrow,
    })}>
      <div className={cx(classes.iconWrapper, { [classes.smallMobile]: isSmallMobile })}>
        <img className={classes.icon} src={icon} alt="" />
      </div>
      <div className={classes.wrapper}>
        <h2 className={classes.title}>{intl.formatMessage({ id: title }, { noBreak: <>&nbsp;</> })}</h2>
        {content.map((item) => (
          <p className={classes.font} key={item}>{intl.formatMessage(
            { id: item },
            {
              sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
              span: (chunks: ReactNode) => <span className={classes.nowrap}>{chunks}</span>,
              noBreak: <>&nbsp;</>,
            },
          )}</p>
        ))}
        {list && (
          <ul className={classes.list}>
            {list.map((item) => (
              <li className={classes.font} key={item}>{intl.formatMessage(
                { id: item },
                { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
              )}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
